// extracted by mini-css-extract-plugin
module.exports =  {"chips":"_0d624b9a27--chips--ax9DS"};